import React, { createContext, useEffect, useState } from "react";
import { useImageList } from "./ImageList";

const ImageAssetContext = createContext({});

const ImageAssetProvider = ({ children, setIsImageAssets }) => {
  const { imageList } = useImageList();
  const [images, setImages] = useState({});

  useEffect(() => {
      setImages(imageList);
      setIsImageAssets(true)
  }, [imageList]);

  return (
    <ImageAssetContext.Provider value={images}>
       {children}
    </ImageAssetContext.Provider>
  );
};

export { ImageAssetProvider, ImageAssetContext };
